export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const REFRESH_TOKEN_SUB_URL = 'auth/refresh';
export const ACCESS_TOKEN_KEY = 'access_token';

export const BLOCKCHAINS = [
  { value: 'ARBITRUM', label: 'Arbitrum Network', explorerDomain: 'arbiscan.io' },
  { value: 'AURORA', label: 'Aurora', explorerDomain: 'aurorascan.dev' },
  { value: 'AVALANCHE', label: 'Avalanche Network', explorerDomain: 'snowtrace.io' },
  { value: 'BASE', label: 'Base', explorerDomain: 'basescan.org' },
  { value: 'BINANCE_SMART_CHAIN', label: 'Binance smart chain', explorerDomain: 'bscscan.com' },
  { value: 'CRONOS', label: 'Cronos', explorerDomain: 'cronoscan.com' },
  { value: 'ETHEREUM', label: 'Ethereum mainnet', explorerDomain: 'etherscan.io' },
  { value: 'FANTOM', label: 'Fantom', explorerDomain: 'ftmscan.com' },
  { value: 'METIS', label: 'Metis', explorerDomain: 'metiscan.io' },
  { value: 'OPTIMISM', label: 'Optimism', explorerDomain: 'optimistic.etherscan.io' },
  { value: 'POLYGON', label: 'Polygon', explorerDomain: 'polygonscan.com' },
  { value: 'PULSE', label: 'Pulse', explorerDomain: 'pulsescan.com' },
  { value: 'XDAI', label: 'Gnosis (xDai)', explorerDomain: 'gnosisscan.io' },
];

export const MAINNET = 'MAINNET';
export const TESTNET = 'TEST';

export const networks = (blockchain: string) => {
  switch (blockchain) {
    case 'ETHEREUM':
      return [
        { value: MAINNET, label: 'Mainnet' },
        { value: 'GOERLI', label: 'Goerli' },
        { value: 'KOVAN', label: 'Kovan' },
        { value: 'RINKEBY', label: 'Rinkeby' },
        { value: 'ROPSTEN', label: 'Ropsten' },
        { value: 'SEPOLIA', label: 'Sepolia' },
      ];
    case 'XDAI':
      return [
        { value: MAINNET, label: 'Mainnet' },
      ];
    default:
      return [
        { value: MAINNET, label: 'Mainnet' },
        { value: TESTNET, label: 'Testnet' },
      ];
  }
};
